import { useEffect, useState } from 'react';
import { BodyText, Stack } from '@servicetitan/design-system';

import * as Styles from './auth-redirection.module.less';

export const AuthRedirection = () => {
    const [dotCount, setDotCount] = useState(1);

    useEffect(() => {
        const intervalId = setInterval(() => {
            setDotCount(prevCount => (prevCount + 1) % 4);
        }, 300);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <Stack className={Styles.overlay} alignItems="center" justifyContent="center">
            <BodyText className={Styles.text}>
                Redirecting to Sign in page{'.'.repeat(dotCount)}
            </BodyText>
        </Stack>
    );
};
